import { render, staticRenderFns } from "./TaxonomyRelations.vue?vue&type=template&id=1f3d2660&"
import script from "./TaxonomyRelations.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyRelations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports